import {Button, Col, Divider, Form, Input, message, Modal, Radio, Row, Space, Spin, Typography} from "antd";
import {CustomerWrapperDto} from "../../dto/CustomerWrapperDto";
import UserDetails from "./userDetail";
import ContactDetails from "./contactDetail";
import OccupationDetails from "./occupationDetail";
import BankAccountDetails from "./bankAccountDetail";
import OtherDetail from "./otherDetail";
import AttachmentAndSupportingDetail from "./attachmentAndSupportingDetail";
import Acknowledgement from "./acknowledgment";
import {useHistory} from "react-router-dom";
import React, {useEffect, useRef, useState} from 'react';
import customerService from "../../service/customerService";
import {
    MSG_CUSTOMER_CREATION_FAILURE_ERROR,
    MSG_OTP_IS_INVALID,
    MSG_OTP_SEND_FAILURE_ERROR,
    MSG_OTP_VERIFICATION_FAILURE_ERROR,
    MSG_OTP_VERIFICATION_SUCCESS,
    MSG_SUMMERY_PDF_DOWNLOAD_ERROR,
    MSG_VERIFY_RM_CODE
} from "../../util/Messages";
import ErrorHandler from "../../util/ErrorHandler";
import SecondApplicantDetail from "../jointAccSteps/secondApplicantDetail";
import {ACCOUNT_TYPE} from "../../util/Constants";
import {CheckCircleOutlined} from "@ant-design/icons";
import Validation from "../../util/Validation";
import {OtpRequestDto} from "../../dto/OtpRequestDto";
import signupService from "../../service/signupService";
import {OtpDataDto} from "../../dto/OtpDataDto";
import {InputOTP} from "antd-input-otp";
import {load} from "worker-timers-broker";
import {ValidateOtpDto} from "../../dto/ValidateOtpDto";


interface SummaryDetailProps {
    savedCusDetailFromPreviousStep: CustomerWrapperDto,
}

const SummaryDetail = (props: SummaryDetailProps) => {
    type otpInputType =
        "numeric"
        | "alphabet"
        | "symbol"
        | "alphabet-symbol"
        | "alphabet-numeric"
        | "numeric-symbol"
        | "all";
    const history = useHistory();
    const [isSpinnerLoading, setSpinnerLoading] = useState<boolean>(false);
    const [isButtonLoading, setButtonLoading] = useState<boolean>(false);
    const [isRMCodeVerified, setRMCodeVerified] = useState<boolean>(false);
    const [isRMPresent, setRMPresent] = useState<boolean>(false);
    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const [otpData, setOtpData] = useState<OtpDataDto>({
        message: "",
        otpRef: "",
        refId: "",
        retryCount: 0,
        tokenLength: 6,
        validityPeriod: 120,
        resendPeriod: 120,
        tokenType: "numeric",
    });
    const [isResendDisable, setIsResendDisable] = useState(true);
    const otpFormRef: React.RefObject<HTMLFormElement> = React.createRef();
    const [timer, setTimer] = useState("");
    const [rmCode, setRMCode] = useState("");
    const timeoutRef = useRef<load>();
    const [otpDestination, setOtpDestination] = useState({
        type: "",
        destination: "",
        maskedDestination: "",
        rmCode: ""
    });
    const [value, setValue] = useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [form] = Form.useForm();
    const otpApplicationId: string | undefined = process.env.OTP_APPLICATION_ID ? process.env.OTP_APPLICATION_ID : "";


    const getFilledDateFromSteps = () => {
    }
    // const goToVideoSchedule = () => {
    //     if (isDocumentDownloaded) {
    //         history.push('/make-video-appointment')
    //     } else {
    //         message.warning(MSG_SUMMERY_PDF_DOWNLOAD_WARN)
    //     }
    // }


    useEffect(() => {
        form.setFieldsValue({isRMPresent: false})
    }, []);

    const downloadSummery = () => {
        setSpinnerLoading(true)
        setButtonLoading(true)
        let customerMstDto = props.savedCusDetailFromPreviousStep.customerMstDto;
        let id: number = (undefined != customerMstDto && undefined != customerMstDto.id) ? customerMstDto.id : 0;
        customerService.generateCustomerSummaryPdf(id).then(res => {
            if (res.data !== null) {
                let a = document.createElement('a');
                a.href = res.data.results;
                a.download = "Summary Document";
                a.click();
                setSpinnerLoading(false)
                setButtonLoading(false)
                // setTimeout(() => {
                //     history.push('/make-video-appointment')
                // }, 600)
            } else {
                message.error(MSG_SUMMERY_PDF_DOWNLOAD_ERROR).then();
                setSpinnerLoading(false)
                setButtonLoading(false)

            }
        }).catch(reason => {
            ErrorHandler.handleError(reason);
            setSpinnerLoading(false)
            setButtonLoading(false)

        })

    }

    const generateSummaryPdf = () => {
        let customerMstDto = props.savedCusDetailFromPreviousStep.customerMstDto;
        let id: number = (undefined != customerMstDto && undefined != customerMstDto.id) ? customerMstDto.id : 0;
        return customerService.generateCustomerSummaryPdf(id);
    }

    const generateOtpForRMCode = () => {
        setSpinnerLoading(true)
        let rmCode = form.getFieldValue("rmCode");
        setRMCode(rmCode)
        otpFormRef.current?.resetFields();
        setValue([])

        let otpRequestDto: OtpRequestDto = {
            rmCode: rmCode,
        }

        signupService.customerOriginalSeenOtp(otpRequestDto).then((res: any) => {
            if (res.data !== null) {
                let otpData: OtpDataDto = res.data.results;
                setOtpData(otpData)
                setOtpDestination({
                    type: "",
                    destination: "",
                    maskedDestination: "",
                    rmCode: rmCode
                })
                showModal();
                countdown(true)
                setSpinnerLoading(false)
            } else {
                message.error(MSG_OTP_SEND_FAILURE_ERROR).then();
                setSpinnerLoading(false)
                setRMCode("")
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinnerLoading(false)
            setRMCode("")

        })
    }

    const showModal = () => {
        setModalOpen(true);
    };
    const countdown = (enable: boolean) => {
        let seconds = otpData.resendPeriod;
        setTimer("0:00")

        function tick() {
            const minutesRemaining = Math.floor(seconds / 60);
            const secondsRemaining = seconds % 60;
            --seconds;
            setTimer(`${minutesRemaining.toString().padStart(2, '0')}:${secondsRemaining.toString().padStart(2, '0')}`);
            if (seconds >= 0) {
                timeoutRef.current = setTimeout(tick, 1000);
                setIsResendDisable(true);
            } else {
                setIsResendDisable(false);
            }
        }

        if (enable) {
            tick()
        } else {
            if (typeof timeoutRef.current === "number") {
                clearTimeout(timeoutRef.current);
            }
        }
    }
    const handleCancel = () => {
        setModalOpen(false);
        countdown(false)
        setRMCode("")
    };

    const handleOk = () => {
        setModalOpen(false);
    };

    const validateOtp = () => {
        let userOtp = otpFormRef.current?.getFieldValue("userOtp");
        if (!userOtp || userOtp.includes(undefined) || userOtp.includes("") || userOtp.length != otpData.tokenLength) {
            return otpFormRef.current?.setFields([
                {
                    name: "userOtp",
                    errors: [MSG_OTP_IS_INVALID]
                }
            ]);

        } else {
            let validateOtpDto: ValidateOtpDto = {
                refId: otpData.refId,
                appId: otpApplicationId,
                otp: userOtp.join(''),
                otpRef: otpData.otpRef
            }
            signupService.validateOtp(validateOtpDto).then((res: any) => {
                if (res.data !== null && res.data.status == "SUCCESS") {
                    message.success(MSG_OTP_VERIFICATION_SUCCESS).then();
                    handleOk();
                    setRMCodeVerified(true);
                    countdown(false)
                } else {
                    message.error(MSG_OTP_VERIFICATION_FAILURE_ERROR).then();
                    setRMCodeVerified(false);
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setRMCodeVerified(false);
            })
        }
    }


    const onDone = () => {
        form.validateFields().then(() => {
            setSpinnerLoading(true)
            let rmCode = form.getFieldValue("rmCode");
            if (isRMPresent) {
                if (!isRMCodeVerified) {
                    message.warning(MSG_VERIFY_RM_CODE)
                    setSpinnerLoading(false)
                } else {
                    let customerMstDto = props.savedCusDetailFromPreviousStep.customerMstDto;
                    customerService.customerOriginallySeen(rmCode, String(customerMstDto.id)).then((res: any) => {
                        if (res.data.results) {
                            generateSummaryPdf().then(res =>{
                                history.push('/workflow/customer/dashboard')
                            }).catch(()=>{
                                setSpinnerLoading(false)
                            })
                        } else {
                            message.error(MSG_CUSTOMER_CREATION_FAILURE_ERROR).then();
                            setRMCodeVerified(false);
                        }
                    }, (reason) => {
                        ErrorHandler.handleError(reason);
                        setSpinnerLoading(false)
                    })
                }
            } else {
                generateSummaryPdf().then(res =>{
                    history.push('/make-video-appointment')
                }).catch(()=>{
                    setSpinnerLoading(false)
                })
            }

        }).catch(() => {

        });

    }


    const handleValuesChange = (changedValues: any, allValues: any) => {
        setIsButtonDisabled(!allValues.rmCode);
    };

    const onChangeRmCode = (event: Event) => {
        if ((event.target as HTMLInputElement).value != rmCode) {
            setRMCodeVerified(false);
        } else {
            if ((event.target as HTMLInputElement).value == "" && rmCode == "") {
                setRMCodeVerified(false);
            } else {
                setRMCodeVerified(true)
            }
        }
    }

    const onChangeRMPresent = (e: Event) => {
        const value = (e.target as HTMLInputElement).value as unknown as boolean;
        setRMPresent(value)
        if (!value){
            form.resetFields(["rmCode"]);
            setRMCodeVerified(false)
            setRMCode("")
        }
    }
    return (
        <div>
            <Spin spinning={isSpinnerLoading} size="large" tip="Loading">
                <div>
                    <h1 className='summary-page-header'>Summary</h1>
                    <UserDetails getStepperFilledData={getFilledDateFromSteps}
                                 currentCustomerDetail={props.savedCusDetailFromPreviousStep}
                                 isFromSummaryView={true}

                    />
                    <Divider/>
                    <ContactDetails
                        savedCusDetailFromPreviousStep={props.savedCusDetailFromPreviousStep}
                        getStepperFilledData={getFilledDateFromSteps}
                        isFromSummaryView={true}
                    />
                    <Divider/>
                    <OccupationDetails
                        savedCusDetailFromPreviousStep={props.savedCusDetailFromPreviousStep}
                        getStepperFilledData={getFilledDateFromSteps}
                        isFromSummaryView={true}
                    />
                    <Divider/>
                    <BankAccountDetails
                        savedCusDetailFromPreviousStep={props.savedCusDetailFromPreviousStep}
                        getStepperFilledData={getFilledDateFromSteps}
                        isFromSummaryView={true}
                    />
                    <Divider/>
                    <OtherDetail
                        savedCusDetailFromPreviousStep={props.savedCusDetailFromPreviousStep}
                        getStepperFilledData={getFilledDateFromSteps}
                        isFromSummaryView={true}
                    />
                    <Divider/>
                    <AttachmentAndSupportingDetail
                        isFromSummaryView={true}
                        savedCusDetailFromPreviousStep={props.savedCusDetailFromPreviousStep}
                        getStepperFilledData={getFilledDateFromSteps}
                    />
                    <Acknowledgement
                        savedCusDetailFromPreviousStep={props.savedCusDetailFromPreviousStep}
                        getStepperFilledData={getFilledDateFromSteps}
                        isFromSummaryView={true}
                    />
                    {
                        props.savedCusDetailFromPreviousStep.customerMstDto.initialAccountTypeId == ACCOUNT_TYPE.JOINT_ACCOUNT &&
                        (props.savedCusDetailFromPreviousStep.customerMstDto.jointReferenceNumber == null || props.savedCusDetailFromPreviousStep.customerMstDto.jointReferenceNumber == "") ?
                            <SecondApplicantDetail
                                isFromSummaryView={true}
                                savedCusDetailFromPreviousStep={props.savedCusDetailFromPreviousStep}
                                getStepperFilledData={getFilledDateFromSteps}
                            /> : ''
                    }

                    <Form
                        className='form-input'
                        layout={"vertical"}
                        form={form}
                        // onFinish={onSubmit}
                        onValuesChange={handleValuesChange}
                    >
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className={'margin_top_20'}>
                                <Form.Item
                                    label="Are you physically present with the Relationship Manager (RM)?"
                                    name={"isRMPresent"}
                                    rules={
                                        [{
                                            required: true,
                                            message: 'Please select whether relationship manager physically present'
                                        }]}>
                                    <Radio.Group optionType="button"
                                                 buttonStyle="solid"
                                                 getPopupContainer={(trigger: {
                                                     parentNode: any;
                                                 }) => trigger.parentNode}
                                                 onChange={onChangeRMPresent}
                                    >

                                        <Radio.Button value={true}>Yes</Radio.Button>
                                        <Radio.Button value={false}>No</Radio.Button>

                                    </Radio.Group>

                                </Form.Item>
                            </Col>
                            {isRMPresent ?
                                <Col xl={12} lg={12} md={24} sm={24} xs={24} className={"ant-col-xxl-12"}>
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "end"
                                    }} className={'change-email-input'}>
                                        <Form.Item style={{marginBottom: 8, width: '100%'}}

                                                   label={
                                                       <>
                                                           {
                                                               isRMCodeVerified ?
                                                                   <>
                                                                       Relationship Manager Code <span style={{
                                                                       color: 'green',
                                                                       fontSize: 12,
                                                                       paddingLeft: 8
                                                                   }}>Verified </span> <CheckCircleOutlined
                                                                       style={{
                                                                           color: 'green',
                                                                           fontSize: 10,
                                                                           padding: 3
                                                                       }}/>
                                                                   </> :
                                                                   <>Relationship Manager Code</>
                                                           }

                                                       </>
                                                   }
                                                   name={"rmCode"}
                                                   onKeyPress={Validation.isNumberWithoutDot}
                                                   onChange={onChangeRmCode}
                                                   rules={[
                                                       {
                                                           required: isRMPresent,
                                                           message: 'Please enter relationship manager code'
                                                       }
                                                   ]}>
                                            <Input className={"email_input_width"} placeholder="Enter rm code"/>
                                        </Form.Item>

                                        {!isRMCodeVerified ?
                                            <div className={'change-email-verify-btn'}>
                                                <Button
                                                    type="link"
                                                    disabled={isButtonDisabled}
                                                    onClick={generateOtpForRMCode}
                                                    className={"otp_button_verify "}>
                                                    Verify
                                                </Button>
                                            </div> : <></>}

                                    </div>

                                </Col> : <></>}
                        </Row>
                    </Form>
                    <Modal title={"RM CODE VERIFICATION"}
                           open={isModalOpen}
                           destroyOnClose={true}
                           maskClosable={false}
                           closable={false}
                           className='otp-verification-modal'
                           footer={[
                               <Button
                                   // disabled={isResendDisable}
                                   onClick={handleCancel}
                                   className='otp-close-btn'>Close</Button>,
                               <Button type="success" onClick={validateOtp} className='otp-verify-btn'>Verify</Button>,
                           ]}>
                        <p className='otp-sent-info'>Enter the OTP sent to the registered contact number for
                            RM <b>{otpDestination.rmCode}</b></p>

                        <Form name="complex-form" ref={otpFormRef}>
                            <Form.Item>

                                <Form.Item
                                    noStyle
                                    name="userOtp"
                                    rules={[{validator: async () => Promise.resolve()}]}
                                >
                                    <InputOTP length={otpData.tokenLength}
                                              inputType={otpData.tokenType.toLowerCase() as otpInputType}
                                              onChange={() => setValue}
                                              value={value}/>
                                </Form.Item>

                                <Typography href="#API">
                                    <p>Didn't you receive the OTP?
                                        <Button type="link" disabled={isResendDisable}
                                                onClick={generateOtpForRMCode}>
                                            Resend
                                        </Button>
                                        <span style={{float: 'right', paddingTop: 4}}>{timer}</span>
                                    </p>
                                </Typography>


                            </Form.Item>
                        </Form>

                    </Modal>
                    <Row>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Divider></Divider>
                        </Col>
                    </Row>
                    <Space style={{float: 'right'}} className='form_next_btn_col'>
                        <Form.Item>
                            <Button className='form_download_and_next_btn' type="primary" loading={isButtonLoading}
                                    onClick={downloadSummery}>
                                Download
                            </Button>
                            <Button className='form_next_btn' htmlType="submit" type="primary" onClick={onDone}>
                                Done
                            </Button>
                        </Form.Item>
                    </Space>
                </div>
            </Spin>
        </div>
    )

}
export default SummaryDetail;

